import { useEffect } from 'react';

// A map selection updates only the location, preserving the rest of the draft.
// undefined leaves the form in charge; null invalidates a previous map selection.
export default function useExternalFormAddress({
    isOpen,
    address,
    isResolving,
    setSelectedAddress,
    setFormState,
    setValidationError,
}) {
    useEffect(() => {
        if (!isOpen || address === undefined) return;
        const selection = isResolving ? null : address;
        setSelectedAddress(selection);
        setFormState((current) => ({ ...current, addressDisplay: selection?.label || '' }));
        setValidationError(null);
    }, [address, isResolving, isOpen, setSelectedAddress, setFormState, setValidationError]);
}
